import { ChevronDown } from "lucide-react"
import React from "react"

// ----------------------------------------------------------------------

// Create a wrapper component for ChevronDown to match MUI Icon API
const ChevronDownIcon = (props: any) =>
  React.createElement(ChevronDown, { ...props, size: 24, "aria-label": "Expand dropdown" })

export default function Select() {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ChevronDownIcon
      },

      styleOverrides: {
        root: {}
      }
    }
  }
}
